<!-- @format -->
<!-- <script>
  export let name;
</script>
<h1>Hello, {name}!</h1>
<p>This is the Home page.</p> -->

<script>
  import { onMount } from "svelte";

  let lineBreakText = "";
  let isMobile = false;
  let showMenuPopup = false;
  var element = null;

  onMount(() => {
    // lineBreakText = "毎日に、\nハジける発見";
    // lineBreakText = "매일이,\n새로운 발견";
    // lineBreakText = "갖고 싶은 것\n보고 싶은 것";
    // lineBreakText = "All Showcases,\nAll in One";

    // lineBreakText = "Your Video,\nNow Your Shop";
    // lineBreakText = "All videos will have be\nAll Shop";
    // lineBreakText = "Every video\nbecomes a store";
    // lineBreakText = "I want to see\nwhat I want to have";
    // lineBreakText = "Video Commerce\nfor Consumer & Brands";
    // lineBreakText = "My Video,\nNow My Shop";
    // lineBreakText = "Here's to your health";
    // lineBreakText = "나의 비디오,\n이제 나의 상점";
    // lineBreakText = "Discover Showcased Videos and Products"
    // lineBreakText = "Discover showcased<br />videos and products"
    lineBreakText = "Short videos,<br/>Snappy shopping!";
    // lineBreakText = "Discover displayed videos and products"

    // 초기 화면 너비
    const { innerWidth, innerHeight } = window;

    // 브라우저 창 너비에 따라 모바일 여부 판별
    isMobile = innerWidth < 800000 || innerHeight < 600000;
    // isMobile = innerHeight < 600;

    // 화면 크기 변경 감지 이벤트 등록
    window.addEventListener("resize", () => {
      const { innerWidth } = window;
      isMobile = innerWidth < 800000 || innerHeight < 600000;
      // isMobile = innerHeight < 600;
    });

    // // 메뉴버튼 이벤트 리스너
    // const menuButton = document.getElementById("mobile-menu-button");
    // menuButton.addEventListener("click", openMenuPopup);

    // const closeButton = document.getElementById("mobile-close-button");
    // closeButton.addEventListener("click", closeMenuPopup);
  });

  const isIOS =
    /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

  const isAndroid = /Android/.test(navigator.userAgent);

  // import { Link } from "svelte-routing";

  // import About from "./About.svelte";

  // export let src = "images/nuguri.jpg";
  // export let src = "images/mockup-image-01.jpg";
  // export let logosrc = "images/nuguri.jpg";
  // export let logosrc = "images/vlogo2.png";
  export let logosrc = "images/slogo2.png";
  // export let logosrc = "images/hlogo.png";
  // export let logosrc = "images/hlogo3.png";
  export let srcf = "images/frame.svg";
  // export let srcr = "images/frameright.svg";
  // export let srcl = "images/frameleft.svg";
  // export let srcu = "images/frameup.svg";
  // export let videosrc = "images/GB.mp4";
  export let videosrc = "images/output.mp4";
  export let buttonsrc1 = "images/buttonapple-en.png";
  export let buttonsrc2 = "images/buttonandroid-en.png";
  // export let name;

  function disableScroll(event) {
    event.preventDefault();
  }

  function goToLink(os) {
    return function(event) {
      if(os === "ios") {
      window.location.href = "https://apps.apple.com/app/shortcase/id6470258809";  
      } else if(os === "android") {
        window.location.href = "https://play.google.com/store/apps/details?id=com.link.shortcase&pli=1";  
      } else {
        
      }
    }
  }

  let items = [
    {
      title: "Simpler Sharing",
      description: "Lorem ipsum dolor amet sit consect adipiscing.",
    },
    {
      title: "Simpler Sharing",
      description: "Lorem ipsum dolor amet sit consect adipiscing.",
    },
    {
      title: "Simpler Sharing",
      description: "Lorem ipsum dolor amet sit consect adipiscing.",
    },
    {
      title: "Simpler Sharing",
      description: "Lorem ipsum dolor amet sit consect adipiscing.",
    },
  ];

  // home bar
  let isLanguagePopupOpen = false; // 언어 팝업이 열려있는지 여부
  let selectedLanguage = ""; // 선택한 언어

  // 팝업 토글 상태를 관리하는 변수입니다.
  let isPopupOpen = false;

  // 메뉴 아이템을 정의합니다.
  const menuItems = [
    { label: "Privacy Policy", link: "#" },
    { label: "Terms of Service", link: "#" },
  ];

  const toggleLanguagePopup = () => {
    isLanguagePopupOpen = !isLanguagePopupOpen;
  };

  const selectLanguage = (lang) => {
    selectedLanguage = lang;
    toggleLanguagePopup();
    // 선택한 언어에 따라 다른 작업을 수행할 수 있습니다.
  };

  // 메뉴버튼
  const openMenuPopup = () => {
    showMenuPopup = true;
  };

  const closeMenuPopup = () => {
    showMenuPopup = false;
  };

  // 화면사이즈 변경에 따라 폰트 사이즈 조절
  element = document.getElementById("myelement");

  function updateFontSize() {
    if (element == null) {
      console.log("element is null");
      element = document.getElementById("myelement");
    }

    // console.log(element);

    // const width = element.offsetWidth;
    // const height = element.offsetHeight;
    const width = window.innerWidth;
    const height = window.innerHeight;
    const fontSize = Math.min(width, height) * 0.09; // 원하는 비율로 조정
    // element.style.fontSize = fontSize + "px";
    // console.log(width, height);
    // element.style.fontSize = fontSize + "px";
    // element.style.fontSize = "100px";
  }

  // 초기 로드 시와 창 크기 변경 시에 updateFontSize() 함수 호출
  window.addEventListener("load", updateFontSize);
  window.addEventListener("resize", updateFontSize);

  function playVideo() {
    var video = document.getElementById("myVideo");
    video.play();
  }
</script>

<!-- 
<Router>
  <nav>
    <Link to="/">Web2</Link>
    <Link to="privacy">privacy</Link>
  </nav>
</Router> -->

<svelte:head />

<main on:wheel={disableScroll} on:touchmove={disableScroll}>
  <!-- <Router {routes} /> -->
  {#if isMobile}
    <nav class="mobile-homebar">
      <div class="mobile-logo">
        <img src={logosrc} alt="Logo" />
        <!-- <svg
          width="62"
          height="40"
          viewBox="0 0 96 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="azOF5"
        >
          <path
            d="M20.759 26.007a9.606 9.606 0 0 0 4.392-2.307c.429-.393.815-.779 1.157-1.171.1.264.208.5.315.707.457.835 1.107 1.192 1.935 1.078.679-.093 1.157-.343 1.422-.743.27-.407.457-1.135.557-2.2a29.82 29.82 0 0 1 .65-3.77c.307-1.293.657-2.365 1.057-3.229.4-.857.764-1.307 1.092-1.35.243-.035.386.129.436.479.057.443.093 1.371.107 2.8-.007 1.607.043 2.828.157 3.664.136.985.429 1.8.879 2.442.457.643 1.043.914 1.771.822.7-.093 1.186-.336 1.457-.736.271-.393.457-1.136.557-2.221.15-1.386.407-2.714.771-3.993.365-1.278.758-2.321 1.186-3.128.429-.807.786-1.229 1.071-1.264.243-.036.386.128.436.478.071.529.057 1.5-.043 2.921-.093 1.622-.1 2.743-.021 3.357.164 1.229.578 2.129 1.235 2.7.657.571 1.543.779 2.664.628 1.386-.185 2.564-.72 3.55-1.614.443-.4.857-.842 1.264-1.32a6 6 0 0 0 1.757 1.606c.971.593 2.121.85 3.45.779 1.57-.086 2.942-.722 4.12-1.9 1.18-1.186 1.929-2.714 2.243-4.593.9-.085 1.757-.242 2.564-.45-.007.322-.014.643-.014.965 0 1.95.171 3.364.514 4.25.343.885.936 1.328 1.779 1.328.685 0 1.192-.186 1.514-.55.321-.365.6-1.072.843-2.107.328-1.35.77-2.636 1.314-3.857.542-1.214 1.071-2.2 1.592-2.943.522-.742.922-1.114 1.215-1.114.242 0 .364.179.364.529 0 .485-.136 1.614-.4 3.385-.307 2.036-.464 3.5-.464 4.385 0 .75.164 1.314.5 1.693.335.379.864.564 1.592.564.772 0 1.336-.185 1.679-.55.343-.364.514-.971.514-1.807 0-1.485.064-2.828.2-4.035.136-1.207.307-2.485.528-3.835.243-1.593.365-2.679.365-3.257 0-.707-.186-1.243-.55-1.614-.365-.364-.9-.55-1.614-.55-.729 0-1.536.257-2.407.764-.872.507-1.764 1.364-2.671 2.557-.907 1.193-1.729 2.75-2.457 4.65.085-.972.2-1.793.328-2.457.136-.665.307-1.443.529-2.329.328-1.242.5-2.035.5-2.392 0-.307-.086-.522-.265-.629-.178-.107-.485-.164-.928-.164-.822 0-1.457.15-1.907.45-.457.3-.778.771-.978 1.414a25.169 25.169 0 0 0-.85 3.585c-1.072.307-2.022.514-2.85.614-.272-1.692-.95-3.092-2.043-4.199-1.092-1.107-2.478-1.614-4.156-1.521a6.67 6.67 0 0 0-3.686 1.314c-1.085.8-1.914 1.878-2.485 3.228-.572 1.35-.807 2.864-.722 4.543.022.37.065.728.129 1.078-.357.514-.679.936-.957 1.257-.529.621-1.014.957-1.457 1.014-.636.086-1.014-.307-1.129-1.185-.085-.615-.042-1.907.115-3.872.185-2.3.214-3.885.1-4.735-.193-1.428-1-2.042-2.429-1.85-1.164.158-2.328.936-3.506 2.35-1.172 1.407-2.129 3.536-2.864 6.385.014-.407.05-1.014.121-1.828.171-1.9.207-3.2.114-3.9-.1-.721-.328-1.242-.693-1.55-.364-.307-.935-.414-1.7-.307-.77.1-1.55.507-2.335 1.2-.785.7-1.514 1.693-2.178 2.993-.664 1.293-1.179 2.835-1.536 4.628-.043-.979-.043-1.8 0-2.464.043-.664.115-1.45.222-2.357.164-1.271.221-2.086.178-2.436-.043-.307-.157-.507-.35-.592-.192-.086-.507-.1-.942-.043-.815.107-1.422.343-1.836.7-.407.357-.671.864-.786 1.528-.435 2.493-.492 5.064-.192 7.707a11.235 11.235 0 0 1-2.029 2.4c-1.085.963-2.114 1.556-3.085 1.785-1.514.35-2.65.085-3.421-.779 2.4-1.214 4.014-2.47 4.835-3.785.821-1.314 1.064-2.714.721-4.207-.293-1.271-.9-2.192-1.828-2.764-.929-.571-2.014-.714-3.264-.421-1.4.321-2.571.993-3.507 2-.935 1.014-1.571 2.228-1.9 3.656-.328 1.429-.321 2.886.022 4.379.05.228.114.442.178.657a82.11 82.11 0 0 1-3.506 2.235c-1.443.864-1.95 1.114-2.307.914-.657-.371-.357-2.035-.079-3.528 1.714-9.185 1.971-11.063.979-12.684-.208-.343-1.186-1.922-2.807-2.079-1.186-.114-2.45.543-3.079 1.507-1.007 1.543.222 2.95.858 6.807.357 2.178.385 4.478.37 9.063-.006 2.65-.12 4.264 1 5.135 1.15.893 2.88.436 3.05.393 1.165-.321 1.729-1.064 2.872-2.221.85-.864 2.114-2.05 3.835-3.35.586.957 1.25 1.486 1.678 1.772 2.136 1.42 4.664.87 5.7.628l.014-.014Zm33.44-15.384c.542-.886 1.25-1.35 2.135-1.4h.164c-.05.35-.064.707-.043 1.057.043.843.272 1.628.679 2.357a4.539 4.539 0 0 0 1.671 1.735c-.121 1.093-.421 1.943-.907 2.543-.486.607-1.086.921-1.793.964-.642.036-1.214-.257-1.728-.871-.507-.614-.8-1.529-.864-2.75-.086-1.55.143-2.764.685-3.642v.007Zm-38.31 5.256c.335-1.057.906-1.671 1.699-1.857.386-.093.721-.035 1.007.157.286.193.471.5.564.907.186.8-.021 1.586-.614 2.357-.593.772-1.493 1.457-2.7 2.05l-.014-.064c-.3-1.314-.286-2.5.05-3.557l.007.007ZM77.183 28.3a197.053 197.053 0 0 0-17.79.042c-5.443.25-10.886.7-16.3 1.343-4.113.493-8.22 1.1-12.298 1.835-2.771.5-5.528 1.05-8.27 1.686-1.393.321-2.807.614-4.179 1.028-.014 0-.028.008-.05.015-.521.143-1.192.621-1.278 1.207-.093.607.414 1.207.871 1.528 1.479 1.043 3.464 1.25 5.178.771.236-.064.472-.128.707-.185l.836-.215c.157-.035.314-.078.471-.114 2.543-.6 5.1-1.128 7.671-1.607a205.098 205.098 0 0 1 11.784-1.842c2.386-.308 4.771-.572 7.164-.793l3.857-.329c.143-.007.278-.021.421-.028.264-.015.521-.036.786-.05l2.071-.129c5.82-.328 11.649-.407 17.477-.228.757.021 1.514.05 2.264.085.707.029 1.721-.142 2.321-.564.443-.307.814-.871.593-1.436-.614-1.556-2.871-1.964-4.307-2.02ZM90.68 11.658c1.315-.628 2.279-1.328 2.893-2.114.614-.778.943-1.678.986-2.7.064-1.392-.457-2.528-1.557-3.392-1.1-.871-2.593-1.35-4.471-1.436-2.279-.107-4.1.315-5.478 1.265-1.371.942-2.1 2.3-2.179 4.07a4.735 4.735 0 0 0 .508 2.365c.378.757.95 1.42 1.72 1.992-1.313.629-2.278 1.329-2.885 2.093a4.409 4.409 0 0 0-.985 2.578c-.072 1.507.478 2.707 1.642 3.6 1.165.893 2.822 1.393 4.971 1.492 1.529.072 2.871-.1 4.043-.514 1.171-.414 2.092-1.021 2.757-1.835.671-.814 1.028-1.771 1.078-2.878.086-1.857-.928-3.393-3.05-4.593l.008.007Zm-2.05 6.193c-.614.328-1.442.464-2.477.42-.929-.042-1.657-.25-2.179-.613-.528-.365-.778-.865-.75-1.479.029-.578.25-1.1.671-1.564.422-.471 1.15-.914 2.186-1.328 1.364.685 2.3 1.257 2.793 1.72.5.465.735.944.714 1.43-.029.62-.35 1.092-.964 1.42l.007-.006Zm1.172-9.185c-.479.464-1.293.95-2.443 1.45-1.642-.85-2.442-1.772-2.4-2.772.036-.728.336-1.278.908-1.635.571-.364 1.321-.522 2.25-.479 1.678.079 2.492.722 2.435 1.943-.021.528-.271 1.028-.75 1.493Z"
            fill="#0A0A0A"
          />
        </svg> -->
      </div>

      <div class="mobile-right-section">
        <!-- privacy policy 메뉴 버튼  -->
        <!-- stroke="currentColor" -->
        <button on:click={openMenuPopup} class="mobile-menu-button">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="whitesmoke"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="menu-icon"
          >
            <path d="M3 12h18M3 6h18M3 18h18" />
          </svg>
        </button>

        <!-- <div class="mobile-language">
          <button
            on:click={toggleLanguagePopup}
            on:mouseenter={toggleLanguagePopup}
            on:mouseleave={toggleLanguagePopup}
            class="hoverable"
            >Bahasa Indonesia
          </button>
          {#if isLanguagePopupOpen}
            <div class="popup">
              <ul>
                <li on:click={() => selectLanguage("english")}>English</li>
                <li on:click={() => selectLanguage("indonesia")}>
                  Bahasa Indonesia
                </li>
                <li on:click={() => selectLanguage("vietnamese")}>
                  Tiếng Việt
                </li>
                <li on:click={() => selectLanguage("japanese")}>日本語</li>
                <li on:click={() => selectLanguage("korean")}>한국어</li>
              </ul>
            </div>
          {/if}
        </div> -->
      </div>
    </nav>
  {:else}
    <nav class="homebar">
      <div class="logo">
        <img src={logosrc} alt="Logo" />
        <!-- <svg
        width="96"
        height="40"
        viewBox="0 0 96 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="azOF5"
      >
        <path
          d="M20.759 26.007a9.606 9.606 0 0 0 4.392-2.307c.429-.393.815-.779 1.157-1.171.1.264.208.5.315.707.457.835 1.107 1.192 1.935 1.078.679-.093 1.157-.343 1.422-.743.27-.407.457-1.135.557-2.2a29.82 29.82 0 0 1 .65-3.77c.307-1.293.657-2.365 1.057-3.229.4-.857.764-1.307 1.092-1.35.243-.035.386.129.436.479.057.443.093 1.371.107 2.8-.007 1.607.043 2.828.157 3.664.136.985.429 1.8.879 2.442.457.643 1.043.914 1.771.822.7-.093 1.186-.336 1.457-.736.271-.393.457-1.136.557-2.221.15-1.386.407-2.714.771-3.993.365-1.278.758-2.321 1.186-3.128.429-.807.786-1.229 1.071-1.264.243-.036.386.128.436.478.071.529.057 1.5-.043 2.921-.093 1.622-.1 2.743-.021 3.357.164 1.229.578 2.129 1.235 2.7.657.571 1.543.779 2.664.628 1.386-.185 2.564-.72 3.55-1.614.443-.4.857-.842 1.264-1.32a6 6 0 0 0 1.757 1.606c.971.593 2.121.85 3.45.779 1.57-.086 2.942-.722 4.12-1.9 1.18-1.186 1.929-2.714 2.243-4.593.9-.085 1.757-.242 2.564-.45-.007.322-.014.643-.014.965 0 1.95.171 3.364.514 4.25.343.885.936 1.328 1.779 1.328.685 0 1.192-.186 1.514-.55.321-.365.6-1.072.843-2.107.328-1.35.77-2.636 1.314-3.857.542-1.214 1.071-2.2 1.592-2.943.522-.742.922-1.114 1.215-1.114.242 0 .364.179.364.529 0 .485-.136 1.614-.4 3.385-.307 2.036-.464 3.5-.464 4.385 0 .75.164 1.314.5 1.693.335.379.864.564 1.592.564.772 0 1.336-.185 1.679-.55.343-.364.514-.971.514-1.807 0-1.485.064-2.828.2-4.035.136-1.207.307-2.485.528-3.835.243-1.593.365-2.679.365-3.257 0-.707-.186-1.243-.55-1.614-.365-.364-.9-.55-1.614-.55-.729 0-1.536.257-2.407.764-.872.507-1.764 1.364-2.671 2.557-.907 1.193-1.729 2.75-2.457 4.65.085-.972.2-1.793.328-2.457.136-.665.307-1.443.529-2.329.328-1.242.5-2.035.5-2.392 0-.307-.086-.522-.265-.629-.178-.107-.485-.164-.928-.164-.822 0-1.457.15-1.907.45-.457.3-.778.771-.978 1.414a25.169 25.169 0 0 0-.85 3.585c-1.072.307-2.022.514-2.85.614-.272-1.692-.95-3.092-2.043-4.199-1.092-1.107-2.478-1.614-4.156-1.521a6.67 6.67 0 0 0-3.686 1.314c-1.085.8-1.914 1.878-2.485 3.228-.572 1.35-.807 2.864-.722 4.543.022.37.065.728.129 1.078-.357.514-.679.936-.957 1.257-.529.621-1.014.957-1.457 1.014-.636.086-1.014-.307-1.129-1.185-.085-.615-.042-1.907.115-3.872.185-2.3.214-3.885.1-4.735-.193-1.428-1-2.042-2.429-1.85-1.164.158-2.328.936-3.506 2.35-1.172 1.407-2.129 3.536-2.864 6.385.014-.407.05-1.014.121-1.828.171-1.9.207-3.2.114-3.9-.1-.721-.328-1.242-.693-1.55-.364-.307-.935-.414-1.7-.307-.77.1-1.55.507-2.335 1.2-.785.7-1.514 1.693-2.178 2.993-.664 1.293-1.179 2.835-1.536 4.628-.043-.979-.043-1.8 0-2.464.043-.664.115-1.45.222-2.357.164-1.271.221-2.086.178-2.436-.043-.307-.157-.507-.35-.592-.192-.086-.507-.1-.942-.043-.815.107-1.422.343-1.836.7-.407.357-.671.864-.786 1.528-.435 2.493-.492 5.064-.192 7.707a11.235 11.235 0 0 1-2.029 2.4c-1.085.963-2.114 1.556-3.085 1.785-1.514.35-2.65.085-3.421-.779 2.4-1.214 4.014-2.47 4.835-3.785.821-1.314 1.064-2.714.721-4.207-.293-1.271-.9-2.192-1.828-2.764-.929-.571-2.014-.714-3.264-.421-1.4.321-2.571.993-3.507 2-.935 1.014-1.571 2.228-1.9 3.656-.328 1.429-.321 2.886.022 4.379.05.228.114.442.178.657a82.11 82.11 0 0 1-3.506 2.235c-1.443.864-1.95 1.114-2.307.914-.657-.371-.357-2.035-.079-3.528 1.714-9.185 1.971-11.063.979-12.684-.208-.343-1.186-1.922-2.807-2.079-1.186-.114-2.45.543-3.079 1.507-1.007 1.543.222 2.95.858 6.807.357 2.178.385 4.478.37 9.063-.006 2.65-.12 4.264 1 5.135 1.15.893 2.88.436 3.05.393 1.165-.321 1.729-1.064 2.872-2.221.85-.864 2.114-2.05 3.835-3.35.586.957 1.25 1.486 1.678 1.772 2.136 1.42 4.664.87 5.7.628l.014-.014Zm33.44-15.384c.542-.886 1.25-1.35 2.135-1.4h.164c-.05.35-.064.707-.043 1.057.043.843.272 1.628.679 2.357a4.539 4.539 0 0 0 1.671 1.735c-.121 1.093-.421 1.943-.907 2.543-.486.607-1.086.921-1.793.964-.642.036-1.214-.257-1.728-.871-.507-.614-.8-1.529-.864-2.75-.086-1.55.143-2.764.685-3.642v.007Zm-38.31 5.256c.335-1.057.906-1.671 1.699-1.857.386-.093.721-.035 1.007.157.286.193.471.5.564.907.186.8-.021 1.586-.614 2.357-.593.772-1.493 1.457-2.7 2.05l-.014-.064c-.3-1.314-.286-2.5.05-3.557l.007.007ZM77.183 28.3a197.053 197.053 0 0 0-17.79.042c-5.443.25-10.886.7-16.3 1.343-4.113.493-8.22 1.1-12.298 1.835-2.771.5-5.528 1.05-8.27 1.686-1.393.321-2.807.614-4.179 1.028-.014 0-.028.008-.05.015-.521.143-1.192.621-1.278 1.207-.093.607.414 1.207.871 1.528 1.479 1.043 3.464 1.25 5.178.771.236-.064.472-.128.707-.185l.836-.215c.157-.035.314-.078.471-.114 2.543-.6 5.1-1.128 7.671-1.607a205.098 205.098 0 0 1 11.784-1.842c2.386-.308 4.771-.572 7.164-.793l3.857-.329c.143-.007.278-.021.421-.028.264-.015.521-.036.786-.05l2.071-.129c5.82-.328 11.649-.407 17.477-.228.757.021 1.514.05 2.264.085.707.029 1.721-.142 2.321-.564.443-.307.814-.871.593-1.436-.614-1.556-2.871-1.964-4.307-2.02ZM90.68 11.658c1.315-.628 2.279-1.328 2.893-2.114.614-.778.943-1.678.986-2.7.064-1.392-.457-2.528-1.557-3.392-1.1-.871-2.593-1.35-4.471-1.436-2.279-.107-4.1.315-5.478 1.265-1.371.942-2.1 2.3-2.179 4.07a4.735 4.735 0 0 0 .508 2.365c.378.757.95 1.42 1.72 1.992-1.313.629-2.278 1.329-2.885 2.093a4.409 4.409 0 0 0-.985 2.578c-.072 1.507.478 2.707 1.642 3.6 1.165.893 2.822 1.393 4.971 1.492 1.529.072 2.871-.1 4.043-.514 1.171-.414 2.092-1.021 2.757-1.835.671-.814 1.028-1.771 1.078-2.878.086-1.857-.928-3.393-3.05-4.593l.008.007Zm-2.05 6.193c-.614.328-1.442.464-2.477.42-.929-.042-1.657-.25-2.179-.613-.528-.365-.778-.865-.75-1.479.029-.578.25-1.1.671-1.564.422-.471 1.15-.914 2.186-1.328 1.364.685 2.3 1.257 2.793 1.72.5.465.735.944.714 1.43-.029.62-.35 1.092-.964 1.42l.007-.006Zm1.172-9.185c-.479.464-1.293.95-2.443 1.45-1.642-.85-2.442-1.772-2.4-2.772.036-.728.336-1.278.908-1.635.571-.364 1.321-.522 2.25-.479 1.678.079 2.492.722 2.435 1.943-.021.528-.271 1.028-.75 1.493Z"
          fill="#0A0A0A"
        />
      </svg> -->
      </div>
      <!-- <div class="language">
        <button
          on:click={toggleLanguagePopup}
          on:mouseenter={toggleLanguagePopup}
          on:mouseleave={toggleLanguagePopup}
          class="hoverable"
          >Bahasa Indonesia
        </button>
        {#if isLanguagePopupOpen}
          <div class="popup">
            <ul>
              <li on:click={() => selectLanguage("english")}>English</li>
              <li on:click={() => selectLanguage("indonesia")}>
                Bahasa Indonesia
              </li>
              <li on:click={() => selectLanguage("vietnamese")}>Tiếng Việt</li>
              <li on:click={() => selectLanguage("japanese")}>日本語</li>
              <li on:click={() => selectLanguage("korean")}>한국어</li>
            </ul>
          </div>
        {/if}
      </div> -->
    </nav>
  {/if}

  {#if isMobile}
    <div class="mobile-container">
      <h1>{@html lineBreakText}</h1>
      <div class="mobile-image-container">
        <!-- <img class="image" src={srcl} alt="Image2" /> -->
        <img class="image" src={srcf} alt="Image" />
        <img class="image" src={""} alt="Image2" />
      </div>

      <video
        id="myVideo"
        onclick="playVideo()"
        class="mobile-video"
        src={videosrc}
        loop
        autoplay
        muted
        playsinline
      />

      <div class="mobile-buttonframe">
        {#if isIOS}
          <button class="mobile-image-button" on:click={goToLink("ios")}><img src={buttonsrc1} /></button>
          <!-- <a class="mobile-image-button" href="https://apps.apple.com/app/shortcase/id6470258809"><img src={buttonsrc1} /></a> -->
        {:else if isAndroid}
          <button class="mobile-image-button" on:click={goToLink("android")}><img src={buttonsrc2} /></button>
          <!-- <a class="mobile-image-button" href=""><img src={buttonsrc2} /></a> -->
        {:else}
          <button class="mobile-image-button" on:click={goToLink("ios")}><img src={buttonsrc1} /></button>
          <!-- <a class="mobile-image-button" href="https://apps.apple.com/app/shortcase/id6470258809" ><img src={buttonsrc1} /></a> -->
          <button class="mobile-image-button" on:click={goToLink("android")}><img src={buttonsrc2} /></button>
          <!-- <a class="mobile-image-button" href = ""><img src={buttonsrc2} /></a> -->
        {/if}
      </div>
    </div>
  {:else}
    <!-- <div class="container"> -->
    <!-- <div class="image-container">
        <img class="image" src={srcl} alt="Image2" />
        <img class="image1" src={srcf} alt="Image2" />
        <img class="image" src={srcr} alt="Image2" />
      </div>

      <video class="video" autoplay src={videosrc} loop />

      <h1>{@html lineBreakText}</h1>
      <div class="buttonframe">
        <button class="image-button"><img src={buttonsrc1} /></button>
        <button class="image-button"><img src={buttonsrc2} /></button>
      </div> -->
    <div class="pc-container">
      <div class="pc-image-frame">
        <img src={srcf} alt="" />
        <video autoplay src={videosrc} loop />
      </div>
    </div>
    <div class="pc-container2">
      <!-- <h1 id="myElement">{@html lineBreakText}</h1> -->
      <h1 id="myelement">Hello World</h1>
      <div class="pc-text-frame">
        <button class="pc-image-button">
          <img src={buttonsrc1} />
        </button>
        <button class="pc-image-button">
          <img src={buttonsrc1} />
        </button>
      </div>
    </div>
    <!-- </div> -->
  {/if}

  {#if isMobile}
    <!-- Mobile 버전 Footer -->
    <div class="mobile-footer">
      <div class="mobile-footer-center">
        &copy;2024 Shortcase All Rights Reserved.
      </div>
    </div>
  {:else}
    <!-- PC 버전 Footer -->
    <div class="pc-footer">
      <div class="pc-footer-left">
        <!-- <a href="privacy">Privacy Policy</a> -->
        <a href="#/privacy">Privacy Policy</a>
        <!-- <Link to="/privacy-policy">Privacy Policy</Link> -->
        <a href="#/terms">Terms of Service</a>
      </div>
      <div class="pc-footer-right">&copy;2023 Shortcase All Rights Reserved.</div>
    </div>
  {/if}

  <!-- {#if showMenuPopup} -->
  <div class="mobile-menu-popup {showMenuPopup ? 'open' : 'close'}">
    <!-- <div id="mobile-close-button" class="mobile-close-button"> -->
    <button on:click={closeMenuPopup} class="mobile-close-button">
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ><path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.22 5.22a.75.75 0 0 1 1.06 0l5.834 5.833 5.834-5.833a.75.75 0 0 1 1.06 1.06l-5.833 5.834 5.833 5.834a.75.75 0 0 1-1.06 1.06l-5.834-5.833-5.834 5.833a.75.75 0 0 1-1.06-1.06l5.833-5.834L5.22 6.28a.75.75 0 0 1 0-1.06Z"
          fill="currentColor"
        /></svg
      >
    </button>
    <!-- X 아이콘 또는 이미지 -->
    <!-- </div> -->
    <ul>
      <li><a href="#/privacy">Privacy Policy</a></li>
      <li><a href="#/terms">Terms of Service</a></li>
    </ul>
  </div>
  <!-- {/if} -->
</main>

<style>
  :root {
    /* --primary-color: #fdf852; */
    /* --primary-color: #ffa000ff; */
    --primary-color: #1b1a1d;
    --primary-text-color: whitesmoke;
  }

  .mobile-menu-button {
    width: 42px;
    height: 42px;
    /* width: 36px;
    height: 36px; */
    border-radius: 5px; /* 10% */
    /* background-color: #ffffff; */
    background-color: var(--primary-color);
    border-color: var(--primary-text-color);

    /* 추가적인 스타일링을 위한 속성들 */
  }

  .mobile-menu-popup {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    /* width: 100%;
    height: 100%; */
    background-color: #fff;
    /* background-color: rgba(255, 0, 0, 0.5); */
    /* 추가적인 스타일링을 위한 속성들 */
    display: flex;

    z-index: 100;
    /* 초기 상태 */
    opacity: 0;
    /* transform: translateX(100%); */
    /* transition: opacity 0.3s, transform 0.3s; */
    align-items: center;
    justify-content: center;
    transition-property: transform, opacity;
    transition-duration: 0.3s;
    transition-timing-function: cubic-bezier(0.2, 0, 0.4, 1); /* 가속도 설정 */
  }

  .mobile-menu-popup.open {
    /* 열린 상태 */
    opacity: 1;
    transform: translateX(0);
  }

  .mobile-menu-popup.close {
    /* 열린 상태 */
    opacity: 1;
    transform: translateX(100%);
  }

  /* .mobile-menu-popup ul {
    background-color: #00ff00;
    align-items: center;
    justify-content: center;
  } */

  .mobile-menu-popup li {
    margin-right: 20px;
    margin-left: -20px;
    align-items: center;
    justify-content: center;
    /* background-color: #00f; */
    list-style-type: none; /* 점을 안 보이게 함 */
    margin-bottom: 60px; /* 아래쪽 간격을 10px로 설정 */
  }

  .mobile-menu-popup li a {
    color: #555; /* 텍스트를 검은색으로 설정 */
    text-decoration: none; /* 밑줄을 안 보이게 함 */
    font-size: 1em;
    /* justify-content: center;
    align-items: center; */
    /* color: #fff; */
  }

  .mobile-close-button {
    /* background-color: #f00; */
    /* display: flex; */
    position: absolute;
    top: 1em;
    right: 1em;
    /* width: 60px;
    height: 60px; */

    /* padding: 20px; */
    border: none;
    /* align-items: flex-end; */
    /* justify-content: flex-end; */
    /* background-color: transparent; */
    font-size: 18px;
    /* color: #f00; */
    color: #000;
    /* cursor: pointer; */
    /* z-index: inherit; */
  }

  /* body {
    background-color: #00ffff;
  } */

  /* PC 버전 Footer 스타일 */
  .pc-footer {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    /* padding: 30px; */
    padding: 2rem;
    /* background-color: var(--primary-color); */
    /* background-color: #fff; */
    /* color: #333; */

    z-index: 100;
    height: 10px;
  }

  .pc-footer a {
    margin-right: 10px;
    /* color: #333; */
    color: var(--primary-text-color);
    text-decoration: none;
  }

  .pc-footer a:hover {
    text-decoration: underline;
  }

  .pc-footer-right {
    font-size: 14px;
    color: var(--primary-text-color);
  }

  /* 태블릿/모바일 버전 Footer 스타일 */
  .mobile-footer {
    display: flex;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    justify-content: center;
    align-items: center;
    padding: 1rem;
    padding-bottom: 1.2rem;
    background-color: var(--primary-color);
    /* background-color: #ff0000; */
    color: #333;
    z-index: 10;
  }

  .mobile-footer-center {
    display: flex;
    align-items: center;
    font-size: 0.7em;

    color: var(--primary-text-color);
  }

  .mobile-footer button {
    border: none;
    background-color: transparent;
    font-size: 14px;
    color: #333;
    cursor: pointer;
  }

  .menu-popup {
    position: absolute;
    top: 30px;
    left: 0;
    padding: 10px;
    background-color: #f0f0f0;
    border: 1px solid #ccc;
    z-index: 100;
  }

  .menu-popup a {
    display: block;
    margin-bottom: 10px;
    color: #333;
    text-decoration: none;
  }

  .menu-popup a:hover {
    text-decoration: underline;
  }

  .mobile-footer-right {
    font-size: 14px;
  }

  .mobile-homebar {
    position: absolute;
    /* position: relative; */

    top: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    /* padding: 1rem; */
    /* padding: 30px; */
    padding: 1rem;
    background-color: var(--primary-color);
    /* background-color: #fff; */
    color: #fff;
    /* height: 30px; */
    z-index: 100;
  }

  .mobile-right-section {
    display: flex;
    gap: 10px;
  }

  .homebar {
    position: absolute;
    /* position: relative; */

    top: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    /* padding: 1rem; */
    /* padding: 30px; */
    padding: 2rem;
    /* background-color: var(--primary-color); */
    /* background-color: #fff; */
    color: #fff;
    z-index: 100;
    height: 20px;
  }

  .mobile-logo img {
    /* width: 130px;
    height: 68px; */
    /* width: 142px;
    height: 26px; */
    /* height: 50px;
    width: 180px; */
    height: 45px;
    width: 162px;
  }

  .logo img {
    /* height: 40px; */
    /* height: 39px;
    width: 124px; */
    height: 34px;
    width: 106px;
  }

  .mobile-language {
    position: relative;
    /* font-size: 1em; */
    /* position: absolute; */
    height: 50px;
    padding: 0px;
    /* padding-top: 20px; */
    font-size: 0.85em;
    font-weight: bold;
    /* background-color: #ff0000; */
  }

  .language {
    position: relative;
  }

  .popup {
    position: absolute;
    top: 100%;
    right: 0;
    z-index: 99;
    background-color: #fff;
    color: #000;
    padding: 0.5rem;
    border: 1px solid #ccc;
    border-radius: 5px;
    width: 150px;
  }

  .popup ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  .popup li {
    cursor: pointer;
    padding: 0.5rem;
    border-radius: 5px;
  }

  .popup li:hover {
    background-color: #eee;
  }

  /* main {
    background-color: #0000ff;
    text-align: center;
    padding: 1em;
    margin: 0 auto;
  } */
  main {
    /* background-color: #f00; */
    background-color: var(--primary-color);
    text-align: center;
    display: flex;
    height: 100%;
  }

  button {
    background-color: transparent;
    padding: 12px;
    /* border: #ff0000; */
    border-color: #333;
    border-radius: 5px;
    cursor: pointer;
    /* cursor: pointer;
    caret-color: blue; */
  }

  h1 {
    /* color: #f4f4f5; */
    /* text-transform: uppercase; */
    /* font-size: 4em; */
    /* font-weight: 600; */
    /* color: #ff0000; */
    white-space: pre-wrap;
    margin-bottom: 370px;
    /* margin-right: 45px; */
    font-size: 28px;
    font-weight: 700;
    /* text-align: left; */
    /* font-family: "Noto Sans", sans-serif; */
    line-height: 1.4;
  }

  .mobile-video {
    position: absolute;
    /* width: 80%; */
    /* height: 80%; */
    height: 428px;
    /* margin-right: 200px; */
    margin-top: 248px;
    z-index: -10;
  }

  .video {
    position: absolute;
    width: 76%;
    height: 76%;
    /* height: 430px; */
    margin-bottom: 4px;
    margin-right: 300px;
    z-index: -1;
  }

  .mobile-container {
    position: absolute;
    border: none;
    width: 100%;
    height: 100%;

    background-color: var(--primary-color);

    top: 45%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2;
  }

  .mobile-container h1 {
    color: var(--primary-text-color);
  }

  .container {
    /* background-color: var(--primary-color); */
    background-color: #ff0;
    /* position: absolute; */
    /* position: relative; */
    border: none;
    width: 100%;
    height: 100%;
    flex-direction: column;
    flex-grow: 1;
    /* 화면 스크롤바 숨김 */
    overflow: hidden;

    /* background-color: #fff; */

    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    /* width: 500px; */
    justify-content: center;
    align-items: center;
    z-index: 2;
    /* 
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0) 45%,
      rgba(29, 161, 242, 1) 45%,
      rgba(29, 161, 242, 1) 55%,
      rgba(255, 255, 255, 0) 55%,
      rgba(255, 255, 255, 0) 100%
    );
    animation: move-up 2s linear infinite; */
  }

  .container h1 {
    /* position: absolute; */
    /* position: relative; */
    position: fixed;
    /* color: var(--primary-text-color); */
    /* color: #f00; */
    /* font-size: 14em; */
    /* font-weight: 600; */
    /* color: #ff0000; */
    /* background-color: #f00; */
    white-space: pre-wrap;
    margin-bottom: 300px;
    /* margin-top: 20px; */
    /* padding-top: 200px; */

    /* margin-left: 300px; */
    margin-left: clamp(400px, 3vw, 400px);
    /* margin-right: 45px; */
    /* font-size: 40px; */
    /* font-size: 4rem; */
    font-size: clamp(14px, 4vw, 100px);
    font-weight: 800;
    text-align: left;
    /* font-family: "Noto Sans", sans-serif; */
    line-height: 1.4;
    background-color: #f00;
  }

  @keyframes move-up {
    0% {
      background-position: 0% 100%;
    }
    100% {
      background-position: 0% 0%;
    }
  }

  .image-container {
    /* position: relative; */
    /* justify-content: flex-end; */
    /* background-color: #f00; */
    width: 100%;
    height: 100%;
  }

  .image-container img:first-child {
    top: 0;
    left: 0;
    /* width: 160px; */
    width: 10px;
    z-index: 0;
    /* padding-top: 50px; */
    /* background-color: #ff0000; */
    align-self: flex-end;
    /* margin-top: 100px; */
    margin-right: -10%;
    margin-bottom: -5%;
    display: none;
  }

  .image-container img:last-child {
    /* position: absolute; */
    /* position: relative; */
    /* top: 0;
    left: 0; */
    margin-bottom: 15%;
    /* padding-bottom: 20%; */
    margin-left: -10%;
    /* height: 10%; */
    top: 0px;
    left: 20px;
    z-index: -1;
    /* background-color: #0000ff; */
    display: none;
  }

  .image-container .image1 {
    /* color: #ff0; */
    /* background-color: #f00; */
    /* margin-right: 20%; */
    margin-right: 300px;
    width: 80%;
    height: 80%;
    /* padding-top: 10%;
    padding-bottom: 10%; */
    /* display: none; */
    /* object-fit: none; */
  }

  .mobile-image-container {
    /* position: relative; */
    position: absolute;
    display: flex;
    justify-content: center;
    /* justify-content: flex-end; */
  }

  .mobile-image-container img:first-child {
    /* .mobile-image-container img:only-child { */
    /* top: 0;
    left: 0; */
    width: 250px;
    z-index: -2;
    margin-top: 250px;
    /* background-color: #ff0000; */
    /* align-self: flex-end; */
    /* margin-top: 100px; */
    /* margin-right: -10%; */
    /* margin-bottom: -5%; */
  }

  .mobile-image-container img:last-child {
    position: absolute;
    /* position: relative; */
    /* top: 0;
    left: 0; */
    /* margin-bottom: -30%; */
    /* padding-bottom: 20%; */
    margin-left: -20%;
    margin-top: 5%;
    /* width: 400px; */

    /* height: 10%; */
    top: 0px;
    /* left: 20px; */
    z-index: -3;
    /* background-color: #0000ff; */
    display: none;
  }

  /* .phone-frame {
    position: relative;
    width: 80%;
    height: 80%;
    overflow: hidden;
  }

  .phone-frame video {
    width: 50%;
    height: 50%;
    object-fit: cover;
  } */

  .image {
    /* position: absolute; */
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    display: block;
    margin: 0 auto;
  }

  .mobile-buttonframe {
    /* background: linear-gradient(
      to bottom,
     
      rgba(253, 248, 82, 0),
      rgba(253, 248, 82, 1)
    ); */
    background: linear-gradient(
      to bottom,
      /* #fdf85200 0%,
      #fdf852f0 50%,
      #fdf852ff 100%  */ #1b1a1d00 0%,
      #1b1a1df0 50%,
      #1b1a1dff 100%
    );

    height: 120px;
    display: flex;
    justify-content: center;
    position: fixed;
    bottom: 0;
    /* right: 0; */
    flex-direction: row;
    align-items: flex-end;
    width: 400px;
    left: 50%;
    transform: translate(-50%);
    /* top: 50%; */
    /* left: 50%; */
    /* transform: translate(-50%, -50%); */
    /* margin-left: 218px;
    margin-top: 120px; */
  }

  .buttonframe {
    /* background-color: #0f0f0f; */
    position: absolute;
    /* position: relative; */
    bottom: 0;
    right: 0;
    /* display: flex; */
    /* display: block; */
    flex-direction: row;
    align-items: flex-end;
    /* padding: 10px;
    margin-right: 21.8%;
    margin-bottom: 8%; */
    width: 300px;
    height: 50px;
    /* width: 30%; */
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    margin-left: 218px;
    margin-top: 120px;
  }

  .mobile-image-button {
    border: none;
    /* padding: 0;
    background: none;
    cursor: pointer; */
    display: flex;
    justify-content: space-between;
    /* margin-left: 15px; */
    /* margin-top: 30px; */
    /* margin-bottom: 20px; */
  }

  .mobile-image-button img {
    /* width: 100%; */
    width: 160px;
    height: auto;
    display: block;
  }

  .image-button {
    border: none;
    padding: 0;
    background: none;
    cursor: pointer;
    margin-left: 15px;
  }

  .image-button img {
    /* width: 100%; */
    width: 125px;
    height: auto;
    display: block;
  }

  .button {
    /* margin-top: 10px; */
    margin-left: 10px;
    padding: 10px 20px;
    border: none;
    background-color: #3f51b5;
    /* background-color: #ff0000; */
    color: #fff;
    font-size: 16px;
    cursor: pointer;
  }

  .image-frame {
    /* margin: 40px 0; */
    margin-top: 40px;
    margin-bottom: 40px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: center;
  }

  .build-frame {
    /* background-color: aqua; */
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: center;
  }

  .build-frame img {
    width: 25%;
    height: auto;
    margin-right: 10px;
    object-fit: cover;
    object-position: center;
    background-size: contain;
    background-position: center;
    width: 300px;
    height: 300px;
  }

  .square-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
  }

  .square {
    width: 250px;
    height: 250px;
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: white;
    text-align: center;
  }

  .square i {
    font-size: 50px;
    position: absolute;
    top: 10px;
    left: 50%;
    transform: translateX(-50%);
  }

  h2 {
    margin-bottom: 10px;
  }

  /* .image-frame {
    display: flex;
    flex-direction: column;
    align-items: center;
  } */

  .image-container {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .image-frame img {
    width: 25%;
    height: auto;
    margin-right: 10px;
    object-fit: cover;
    object-position: center;
    background-size: contain;
    background-position: center;
    width: 300px;
    height: 300px;
  }

  .separator {
    border-top: 1px solid #ccc;
    margin: 20px 0;
  }

  .left {
    flex: 1;
    margin-right: 24px;
  }

  .right {
    flex: 1;
  }

  .title {
    color: #1d1d20;
    /* color: #f4f4f5; */
    font-size: 56px;
    font-weight: bold;
    margin-bottom: 16px;
    /* text-align: left; */
  }

  .description {
    color: #52525a;
    /* color: #a2a2a8; */
    font-size: 20px;
    margin-bottom: 32px;
    text-align: left;
    line-height: 1.5;
  }

  img {
    /* max-width: 45%; */
    width: 300px;
    height: 450px;
  }

  footer {
    margin-top: 40px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    /* background-color: #f1f1f1; */
  }

  .frame {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 20px;
  }

  .frame1 {
    justify-content: space-between;
    height: 80px;
  }

  .frame2,
  .frame3,
  .frame4,
  .frame5 {
    flex: 1;
    margin: 0 10px;
  }

  .title {
    margin-bottom: 10px;
  }

  .menu {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  .menu li {
    margin-bottom: 5px;
  }

  .hoverable:hover {
    background-color: gray;
    /* background-color: #ff0000; */
  }

  /* img {
    height: 50px;
  } */

  @media (max-width: 800000px) {
    /* .title {
      font-size: 40px;
      color: #0000ff;
    } */
    /* .homebar {
      background-color: #0000ff;
    }
    .pc-footer {
      background-color: #0000ff;
    } */
    main {
      max-width: none;
    }
  }

  @media (min-width: 80001px) {
    /* .title {
      font-size: 44px;
      color: #ff0000;
    } */
    /* .homebar {
      background-color: #ff0000;
    }
    .pc-footer {
      background-color: #ff0000;
    } */
    main {
      max-width: none;
    }
  }

  .pc-container {
    background-color: #0f0;
    display: flex;
    position: relative;
    align-items: center;
    justify-content: flex-end;
    height: 100%;
    flex: 1;
    padding-right: 50px;
  }

  .pc-container2 {
    background-color: #f00;
    display: flex;
    align-items: start;
    justify-content: center;
    height: 300px;
    flex-direction: column;
    flex: 1;
    height: 100%;
    padding-left: 50px;
  }

  .pc-container2 h1 {
    color: #00f;
    margin-right: 50px;
    white-space: pre-wrap;
    text-align: left;
  }

  .pc-text-frame {
    background-color: #ff0;
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
  }

  .pc-container2 button {
    width: 20vh;
    margin: 10px;
  }

  .pc-container2 button img {
    width: 100%;
    height: 100%;
  }

  .pc-image-frame {
    background-color: aqua;
    height: 80%;
    position: relative;
  }

  .pc-image-frame img {
    width: 100%;
    height: 100%;
    position: absolute;
    display: flex;
  }

  .pc-image-frame video {
    width: 100%;
    height: 100%;
    max-width: 90%;
  }
</style>
